import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import '@fortawesome/fontawesome-free/css/all.min.css'
import 'assets/styles/tailwind.css'
import 'react-datepicker/dist/react-datepicker.css'

// layouts

import Admin from 'layouts/Admin.js'
import Auth from 'layouts/Auth.js'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

ReactDOM.render(
    <BrowserRouter>
        <ToastContainer />
        <Switch>
            {/* add routes with layouts */}
            <Route path="/admin" component={Admin} />
            <Route path="/auth" component={Auth} />
            {/* add routes without layouts */}
            <Route path="/login" exact component={Auth} />
            {/* add redirect for first page */}
            <Redirect from="*" to="/login" />
        </Switch>
    </BrowserRouter>,
    document.getElementById('root')
)
